import React from 'react';
import { DatePicker } from '@dbk/ui-datepicker';
import Text from '@dbk/ui-text';




const filterModalIF = ({ type, onChange, value, userSelectionStart, userSelectionEnd ,  defStartDate, defEndDate}) => (
    <div>
        {type === 'date' &&
            <div>
               
                <DatePicker

                    enableYearNavigation
                    enableRangeSelection
                    onChange={onChange}
                    startDate={ defStartDate}
                    endDate={defEndDate}
                    selectionStart={userSelectionStart}
                    selectionEnd={userSelectionEnd}
                    value={value}
                  //  onApply={console.log('Footer selected')}
                />
            </div>
        }


    </div>


)

export default filterModalIF;